export const RENEWALS_SUMMARY_LIST = 'RENEWALS_SUMMARY_LIST';
export const RENEWALS_SUMMARY_LIST_FETCH_FAILED = 'RENEWALS_SUMMARY_LIST_FETCH_FAILED';

export const SET_RENEWALS_SUMMARY_LOADING = 'SET_RENEWALS_SUMMARY_LOADING';

// export const CLICKED_ROW_SUMMARY = 'CLICKED_ROW_SUMMARY';

export const RENEWALS_STATEMENT_FETCH_FAILED = 'RENEWALS_STATEMENT_FETCH_FAILED';

export const YTD_SUMMARY = 'YTD_SUMMARY';
export const DOC_LOADING = 'DOC_LOADING';
export const DOC_LOADING_DONE = 'DOC_LOADING_DONE';
export const DOC_LOADING_ERR = 'DOC_LOADING_ERR';

export const DIGITAL_SEL_DONE = 'DIGITAL_SEL_DONE';
export const DIGITAL_SEL_ERR = 'DIGITAL_SEL_ERR';

export const RESET_RENEWALS_SUMMARY = 'RESET_RENEWALS_SUMMARY';

export const RENEWALS_SUMMARY_DASHBOARD_DETAILS = 'RENEWALS_SUMMARY_DASHBOARD_DETAILS';
// export const RENEWALS_SUMMARY_DASHBOARD_FETCH_FAILED = 'RENEWALS_SUMMARY_DASHBOARD_FETCH_FAILED';

export const RENEWALS_SUMMARY_DASHBOARD_DETAILS_PREV = 'RENEWALS_SUMMARY_DASHBOARD_DETAILS_PREV';
export const RENEWALS_SUMMARY_DASHBOARD_FETCH_FAILED_PREV = 'RENEWALS_SUMMARY_DASHBOARD_FETCH_FAILED_PREV';

export const SHOW_PAGINATION_PROGRESS = 'SHOW_PAGINATION_PROGRESS';

export const RENEWALS_SUMMARY_NO_FILTER_DATA = 'RENEWALS_SUMMARY_NO_FILTER_DATA';
export const RENEWALS_CLEAR_FILTER_ERROR = 'RENEWALS_CLEAR_FILTER_ERROR';

export const RENEWALS_PDF_FETCH_FAILED = 'RENEWALS_PDF_FETCH_FAILED';
export const RENEWALS_PDF_NOT_FOUND = 'RENEWALS_PDF_NOT_FOUND';

export const RENEWALS_EXCEL_FETCH_FAILED = 'RENEWALS_EXCEL_FETCH_FAILED';
export const RENEWALS_EXCEL_NOT_FOUND = 'RENEWALS_EXCEL_NOT_FOUND';

export const ARVATO_SUMMARY = 'ARVATO_SUMMARY';
export const ARVATO_SUMMARY_FAILED = 'ARVATO_SUMMARY_FAILED';

// new
export const RENEWALS_SUMMARY_DASHBOARD = 'RENEWALS_SUMMARY_DASHBOARD';
export const RENEWALS_SUMMARY_DASHBOARD_FETCH_FAILED = 'RENEWALS_SUMMARY_DASHBOARD_FETCH_FAILED';
export const CLICKED_ROW_SUMMARY = 'CLICKED_ROW_SUMMARY';
export const DISABLE_SUBSCRIBER_LEVEL_UPSELL_FLAG = 'DISABLE_SUBSCRIBER_LEVEL_UPSELL_FLAG';
export const AUTO_SUGGEST_SEARCH_SUCCESS = 'AUTO_SUGGEST_SEARCH_SUCCESS';
export const AUTO_SUGGEST_SEARCH_FAILED = 'AUTO_SUGGEST_SEARCH_FAILED';

export const RENEWALS_SERVICE_ERROR = 'RENEWALS_SERVICE_ERROR';
export const REQUEST_RENEWALS_DATA = 'REQUEST_RENEWALS_DATA';
export const RECEIVE_RENEWALS_DATA = 'RECEIVE_RENEWALS_DATA';
export const RENEWALS_SET_PAGE_NUMBER = 'RENEWALS_SET_PAGE_NUMBER';
export const CONCAT_RENEWALS_DATA = 'CONCAT_RENEWALS_DATA';
export const SET_RENEWALS_SEARCH_DETAILS = 'SET_RENEWALS_SEARCH_DETAILS';
export const SET_RENEWALS_REST_PROPS = 'SET_RENEWALS_REST_PROPS';
export const SET_FILTER_QUERY_STRING = 'SET_FILTER_QUERY_STRING';

export const RENEWALS_ALTERNATE_QUOTE_PDF_FETCH_FAILED = 'RENEWALS_ALTERNATE_QUOTE_PDF_FETCH_FAILED';
export const RENEWALS_ALTERNATE_QUOTE_PDF_NOT_FOUND = 'RENEWALS_ALTERNATE_QUOTE_PDF_NOT_FOUND';
export const UPSELL_RENEWALS_USE_QUOTE_FAILED = 'UPSELL_RENEWALS_USE_QUOTE_FAILED';
export const UPSELL_RENEWALS_USE_QUOTE_SUCCESS = 'UPSELL_RENEWALS_USE_QUOTE_SUCCESS';
export const SET_UPLOAD_DOCUMENTS = 'SET_UPLOAD_DOCUMENTS';

export const RENEWALS_SPECILITY_PRODUCTS_APP_FAILED = 'RENEWALS_SPECILITY_PRODUCTS_APP_FAILED';
export const RENEWALS_SPECILITY_PRODUCTS_APP_SUCCESS = 'RENEWALS_SPECILITY_PRODUCTS_APP_SUCCESS';
export const SPECILITY_ONLY_PRODUCTS_APP_FAILED = 'SPECILITY_ONLY_PRODUCTS_APP_FAILED';
export const SPECILITY_ONLY_PRODUCTS_APP_SUCCESS = 'SPECILITY_ONLY_PRODUCTS_APP_SUCCESS';
export const QUICK_RENEWALS_APP_CREATION_SUCCESS = 'QUICK_RENEWALS_APP_CREATION_SUCCESS';
export const QUICK_RENEWALS_APP_CREATION_FAILED = 'QUICK_RENEWALS_APP_CREATION_FAILED';